module.exports = __webpack_public_path__ + "static/media/ic-contact-mail.35e86243.svg";